<template>
  <div class="kpi-managers-recharge-page">
    <div style="margin: 10px 15px;box-shadow: #e2e4e2 0px 6px 8px -2px;">
      <van-cell
        title="充值记录"
        is-link
        value="去查看"
        class="bottom"
        :to="{ name: 'kpi.managers.record'}"
      />
    </div>
    <!-- v-for="(item, index) in info" :key="index" -->
    <div class="item bottom-line">
      <div class="title">
        <div class="point">品牌奖励豆奖金池</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('brand_bonus_bean')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.brandBonusBeanTotalPool||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.brandBonusBeanAvailablePool||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">导购员奖励豆奖金池</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('staff_bonus_bean')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.staffBonusBeanTotalPool||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.staffBonusBeanAvailablePool||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">品牌惩罚承诺金池</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('brand_penalty')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.penaltyTotalMoney||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.penaltyAvailableMoney||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">客户分享奖励</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('user_share_bonus')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.userShareBonusTotalMoney||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.userShareBonusAvailableMoney||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">导购员单项奖励金</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('staff_single_bonus')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.staffSingleBonusTotalMoney||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.staffSingleBonusAvailableMoney||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">直播间红包</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('live_red_package')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.liveRedPackageTotalMoney||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.liveRedPackageAvailableMoney||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div class="item bottom-line">
      <div class="title">
        <div class="point">其他推广费用</div>
        <div class="btn" v-if="true">
          <van-button type="info" plain @click="recharge('other_promotion_expenses')">发起充值</van-button>
        </div>
      </div>
      <div class="info">
        <span class="money">
          <div class="flag">{{BrandManageDetail.otherPromotionExpensesTotalMoney||0}}</div>
          <div class="word">总额</div>
        </span>
        <span class="money">
          <div class="flag">{{BrandManageDetail.otherPromotionExpensesAvailableMoney||0}}</div>
          <div class="word">余额</div>
        </span>
        <!--<van-button type="info" @click="recharge(item)">充值</van-button>-->
      </div>
    </div>
    <div style="margin: 10px 15px;box-shadow: #e2e4e2 0px 6px 8px -2px;">
      <router-link :to="{path:'/kpi',query: { act_id: act_id}}">
        <van-button type="primary" style="width:100%">返回</van-button>
      </router-link>
    </div>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      info: [],
      BrandManageDetail: {
        staffBonusBeanAvailablePool: 0,
        staffBonusBeanTotalPool: 0,
        brandBonusBeanAvailablePool: 0,
        brandBonusBeanTotalPool: 0,
        staffSingleBonusAvailableMoney: 0,
        staffSingleBonusTotalMoney: 0,
        userShareBonusAvailableMoney: 0,
        userShareBonusTotalMoney: 0,
        liveRedPackageAvailableMoney: 0,
        liveRedPackageTotalMoney: 0,
        otherPromotionExpensesAvailableMoney: 0,
        otherPromotionExpensesTotalMoney: 0,

        staffBonusAvailablePool: 0,
        staffBonusTotalPool: 0,
      },
    };
  },
  created() {
    this.activity_id =
      this.$route.query.act_id || localStorage.getItem("act_id");
    this.getBrandManage();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 品牌奖金池总额和余额
    async getBrandManage() {
      let res = await this.$http.post("/v1/kpiuser/brand_manage");
      console.log(res);
      if (res.data && res.code == 0) {
        // 获取总额和余额
        this.BrandManageDetail = res.data;
      }
    },
    // 跳转到充值
    recharge(item) {
      console.log("充值item", item);
      this.$router.push({
        name: "kpi.managers.pay",
        query: {
          type: item,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-managers-recharge-page {
  font-size: 14px;
  .item {
    background-color: #ffffff;
    padding: 10px 15px;
    margin: 10px 15px;
    box-shadow: #e2e4e2 0px 6px 8px -2px; //边框阴影
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      .point {
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
      .point:before {
        content: "";
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: #5293fd;
        left: 15px;
      }
      .btn {
        .van-button {
          height: 24px;
          line-height: 22px;
          width: 100px;
        }
      }
    }
  }
  .info {
    line-height: 20px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .money {
      color: #5293fd;
      font-size: 16px;
      min-width: 36%;
      .word {
        font-size: 12px;
        color: #666666;
      }
    }
    .flag {
      position: relative;
      margin-left: 14px;
    }
    .flag::before {
      content: "\FFE5";
      position: absolute;
      left: -16px;
    }
  }
}
</style>
